import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  Tabs,
  Tab,
  Box,
  Badge,
} from "@material-ui/core";
import {
  DataGrid,
} from "@material-ui/data-grid/";
import {
  getSiteSpecificPrice,
  getSiteSpecificRetailPrice,
  getSiteSpecificStatus,
  getSiteSpecificDateAdded,
} from "../../../../lib";
import { QuickSearchToolbar, escapeRegExp } from "../../../../lib/utils";
interface Props {
  attribute: string;
  rows: any;
  columns: any;
  rows2: any;
  rows3: any;
  rows4?: any;
  rows5?: any;
  site: any;
  tabTwoName: any;
  tabThreeName: any;
  tabFourName?: any;
  tabFiveName?: any;
}
interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    borderBottom: '2px solid rgba(49, 81, 121, 0.18)',
    backgroundColor: 'transparent',
    minHeight: 40,
    '& .MuiTab-root': {
      minHeight: 40,
      textTransform: 'none',
      fontSize: '0.875rem',
      fontWeight: 500,
      color: '#666',
      padding: theme.spacing(0.75, 2),
    },
    '& .Mui-selected': {
      color: '#315179',
      fontWeight: 600,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#315179',
      height: 2,
    },
  },
}));

export const GroupTabs = (props: Props) => {
  const detailsRows2 = (props?.rows2 ?? []).map((row: any) => {
    return {
      id: row.item_id,
      model: row.model_no,
      title: row.title,
      price: getSiteSpecificPrice(row.price, props.site),
      retail: getSiteSpecificRetailPrice(row, props.site),
      status: getSiteSpecificStatus(row, props.site),
      dateAdded: getSiteSpecificDateAdded(row, props.site),
      buttons: row,
    };
  });
  const detailsRows3 = (props?.rows3 ?? []).map((row: any) => {
    return {
      id: row.item_id,
      model: row.model_no,
      title: row.title,
      price: getSiteSpecificPrice(row.price, props.site),
      retail: getSiteSpecificRetailPrice(row, props.site),
      status: getSiteSpecificStatus(row, props.site),
      dateAdded: getSiteSpecificDateAdded(row, props.site),
      buttons: row,
    };
  });
  const detailsRows4 = (props?.rows4 ?? []).map((row: any) => {
    return {
      id: row.item_id,
      model: row.model_no,
      title: row.title,
      price: getSiteSpecificPrice(row.price, props.site),
      retail: getSiteSpecificRetailPrice(row, props.site),
      status: getSiteSpecificStatus(row, props.site),
      dateAdded: getSiteSpecificDateAdded(row, props.site),
      buttons: row,
    };
  });
  const detailsRows5 = (props?.rows5 ?? []).map((row: any) => {
    return {
      id: row.item_id,
      model: row.model_no,
      title: row.title,
      price: getSiteSpecificPrice(row.price, props.site),
      retail: getSiteSpecificRetailPrice(row, props.site),
      status: getSiteSpecificStatus(row, props.site),
      dateAdded: getSiteSpecificDateAdded(row, props.site),
      buttons: row,
    };
  });
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const [searchText1, setSearchText1] = useState("");
  const [rows1, setRows1] = useState(props?.rows);
  const requestSearch = (searchValue: any) => {
    setSearchText1(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows = props?.rows.filter((row: any) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field]?.toString());
      });
    });
    setRows1(filteredRows);
  };
  const [searchText2, setSearchText2] = useState("");
  const [rows2, setRows2] = useState(detailsRows2);
  const requestSearch2 = (searchValue: any) => {
    setSearchText2(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows2 = detailsRows2.filter((row: any) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field]?.toString());
      });
    });
    setRows2(filteredRows2);
  };
  const [searchText3, setSearchText3] = useState("");
  const [rows3, setRows3] = useState(detailsRows3);
  const requestSearch3 = (searchValue: any) => {
    setSearchText3(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows3 = detailsRows3.filter((row: any) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field]?.toString());
      });
    });
    setRows3(filteredRows3);
  };
  const [searchText4, setSearchText4] = useState("");
  const [rows4, setRows4] = useState(detailsRows4);
  const requestSearch4 = (searchValue: any) => {
    setSearchText4(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows4 = detailsRows4.filter((row: any) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field]?.toString());
      });
    });
    setRows4(filteredRows4);
  };
  const [searchText5, setSearchText5] = useState("");
  const [rows5, setRows5] = useState(detailsRows5);
  const requestSearch5 = (searchValue: any) => {
    setSearchText5(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows5 = detailsRows5.filter((row: any) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field]?.toString());
      });
    });
    setRows5(filteredRows5);
  };
  useEffect(() => {
    if (props?.rows?.length) setRows1(props?.rows);
    if (detailsRows2?.length) setRows2(detailsRows2);
    if (detailsRows3?.length) setRows3(detailsRows3);
    if (detailsRows4?.length) setRows4(detailsRows4);
    if (detailsRows5?.length) setRows5(detailsRows5);
  }, [props.rows]);

  return (
    <div className={classes.root}>
      <Tabs
        className={classes.tabs}
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
      >
          <Tab
            label={
              <Badge
                badgeContent={props?.rows.length}
                max={999}
                color="secondary"
                showZero
              >
                {props.attribute}
              </Badge>
            }
          />
          <Tab
            label={
              <Badge
                badgeContent={props?.rows2?.length}
                max={999}
                color="secondary"
                showZero
              >
                {props.tabTwoName}
              </Badge>
            }
          />
          {props.tabThreeName && (
            <Tab
              label={
                <Badge
                  badgeContent={props?.rows3?.length}
                  max={999}
                  color="secondary"
                  showZero
                >
                  {props.tabThreeName}
                </Badge>
              }
            />
          )}
          {props.tabFourName && (
            <Tab
              label={
                <Badge
                  badgeContent={props?.rows4?.length}
                  max={999}
                  color="secondary"
                  showZero
                >
                  {props.tabFourName}
                </Badge>
              }
            />
          )}
          {props.tabFiveName && (
            <Tab
              label={
                <Badge
                  badgeContent={props?.rows5?.length}
                  max={999}
                  color="secondary"
                  showZero
                >
                  {props.tabFiveName}
                </Badge>
              }
            />
          )}
      </Tabs>
      <TabPanel value={value} index={0}>
      <>
        <DataGrid
          rows={rows1}
          columns={props.columns}
          disableColumnMenu={true}
          autoHeight={true}
          pageSize={100}
          checkboxSelection={false}
          rowHeight={38}
          sortModel={[
            {
              field: "title",
              sort: "asc",
            },
          ]}
          components={{ Toolbar: QuickSearchToolbar }}
          componentsProps={{
            toolbar: {
              value: searchText1,
              onChange: (event: any) => {
                requestSearch(event.target.value);
              },
              clearSearch: () => requestSearch(""),
            },
          }}
        />
        </>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DataGrid
          rows={rows2}
          columns={props.columns}
          disableColumnMenu={true}
          autoHeight={true}
          pageSize={100}
          checkboxSelection={false}
          rowHeight={38}
          sortModel={[
            {
              field: "title",
              sort: "asc",
            },
          ]}
          components={{ Toolbar: QuickSearchToolbar }}
          componentsProps={{
            toolbar: {
              value: searchText2,
              onChange: (event: any) => {
                requestSearch2(event.target.value);
              },
              clearSearch: () => requestSearch2(""),
            },
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <DataGrid
          rows={rows3}
          columns={props.columns}
          disableColumnMenu={true}
          autoHeight={true}
          pageSize={100}
          checkboxSelection={false}
          rowHeight={38}
          sortModel={[
            {
              field: "title",
              sort: "asc",
            },
          ]}
          components={{ Toolbar: QuickSearchToolbar }}
          componentsProps={{
            toolbar: {
              value: searchText3,
              onChange: (event: any) => {
                requestSearch3(event.target.value);
              },
              clearSearch: () => requestSearch3(""),
            },
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <DataGrid
          rows={rows4}
          columns={props.columns}
          disableColumnMenu={true}
          autoHeight={true}
          pageSize={100}
          checkboxSelection={false}
          rowHeight={38}
          sortModel={[
            {
              field: "title",
              sort: "asc",
            },
          ]}
          components={{ Toolbar: QuickSearchToolbar }}
          componentsProps={{
            toolbar: {
              value: searchText4,
              onChange: (event: any) => {
                requestSearch4(event.target.value);
              },
              clearSearch: () => requestSearch4(""),
            },
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <DataGrid
          rows={rows5}
          columns={props.columns}
          disableColumnMenu={true}
          autoHeight={true}
          pageSize={100}
          checkboxSelection={false}
          rowHeight={38}
          sortModel={[
            {
              field: "title",
              sort: "asc",
            },
          ]}
          components={{ Toolbar: QuickSearchToolbar }}
          componentsProps={{
            toolbar: {
              value: searchText5,
              onChange: (event: any) => {
                requestSearch5(event.target.value);
              },
              clearSearch: () => requestSearch5(""),
            },
          }}
        />
      </TabPanel>
    </div>
  );
};
